module.exports = __webpack_public_path__ + "img/powered-by-olsera.3917b697.svg";